import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'

export const Link = ({
  href,
  target,
  children,
  replace,
  state,
  getProps,
  activeStyle,
  activeClassName,
  ...rest
}) => {
  const isInternalLink =
    href.indexOf('/') === 0 && (!target || target === '__self')

  if (isInternalLink) {
    return (
      <GatsbyLink
        to={href}
        replace={replace}
        state={state}
        getProps={getProps}
        activeStyle={activeStyle}
        activeClassName={activeClassName}
        {...rest}
      >
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={href} target={target} {...rest}>
      {children}
    </a>
  )
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
  replace: PropTypes.bool,
  state: PropTypes.object,
  getProps: PropTypes.func,
  activeStyle: PropTypes.object,
  activeClassName: PropTypes.string
}
